import { computed, watch } from "vue"

// Días máximos entre hoy y la fecha de ida para ofrecer el toggle.
// El backend (index.js → runCotizacion) revalida la misma regla.
const DIAS_MAX_CANCELACION_GRATUITA = 14

// fechaIda llega como "YYYY-MM-DD"; se parsea en hora local para no correr
// un día por la zona horaria (new Date("YYYY-MM-DD") la toma como UTC).
function diasHasta(fechaIso) {
  const [y, m, d] = String(fechaIso).split("-").map(Number)
  if (!y || !m || !d) return null

  const hoy = new Date()
  hoy.setHours(0, 0, 0, 0)

  return Math.round((new Date(y, m - 1, d) - hoy) / (1000 * 60 * 60 * 24))
}

export function useCancelacionGratuita(fechaIda, cancelacionGratuita) {

  const mostrarCancelacionGratuita = computed(() => {
    const dias = diasHasta(fechaIda.value)
    return dias !== null && dias >= 0 && dias <= DIAS_MAX_CANCELACION_GRATUITA
  })

  // Si la fecha deja de cumplir la regla, el toggle se oculta y se apaga
  // para que no viaje un valor activo que el usuario ya no ve.
  watch(mostrarCancelacionGratuita, (visible) => {
    if (!visible) cancelacionGratuita.value = false
  })

  return { mostrarCancelacionGratuita }
}
